<video #securedVideoPlayer [class]="videoClass"width="640" height="480" controls controlsList="nodownload">
    <source [src]="dataUrl$|async" type="video/mp4">
    Your browser does not support the video tag.
</video>